/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Collapse_DrawerInputs */



/**
* | output |
* | --- |
* | "Collapse chat" |
*
* @param {Chat_Collapse_DrawerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_collapse_drawer = /** @type {((inputs?: Chat_Collapse_DrawerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Collapse_DrawerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Chat inklappen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réduire le chat")
	return /** @type {LocalizedString} */ ("Collapse chat")
});